import { Sparkles } from "lucide-react";
import {
  DIRECTION_CONFIG,
  RESOLUTION_CONFIG,
  RISK_CONFIG,
  SATISFACTION_CONFIG,
  describe,
  formatScore,
} from "./analysisLabels";

const NEUTRAL =
  "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400";
const TOPIC =
  "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300";
const LOW_SCORE =
  "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300";

// Só o que pede atenção vira etiqueta: risco baixo, cliente satisfeito e conversa
// resolvida são o esperado e não merecem espaço no cabeçalho.
function alertsOf(analysis) {
  const alerts = [];

  if (["alto", "critico"].includes(analysis.riskLevel)) {
    alerts.push(describe(RISK_CONFIG, analysis.riskLevel));
  }
  if (analysis.customerSatisfaction === "insatisfeito") {
    alerts.push(describe(SATISFACTION_CONFIG, analysis.customerSatisfaction));
  }
  if (["pendente", "parcial"].includes(analysis.resolutionStatus)) {
    alerts.push(describe(RESOLUTION_CONFIG, analysis.resolutionStatus));
  }
  if (["escalando", "abandonada", "estagnada"].includes(analysis.conversationDirection)) {
    alerts.push(describe(DIRECTION_CONFIG, analysis.conversationDirection));
  }
  if (typeof analysis.agentScore === "number" && analysis.agentScore <= 6) {
    alerts.push({
      label: `Atendimento ${formatScore(analysis.agentScore)}`,
      badge: LOW_SCORE,
    });
  }

  return alerts;
}

const AnalysisTags = ({ analysis, topicLimit = 2, onClick }) => {
  if (!analysis) return null;

  const alerts = alertsOf(analysis);
  const topics = (analysis.keyTopics || []).slice(0, topicLimit);
  const Wrapper = onClick ? "button" : "div";

  return (
    <Wrapper
      onClick={onClick}
      title={
        onClick ? "Etiquetas da IA — clique para ver a análise completa" : undefined
      }
      className={`flex flex-wrap items-center gap-1.5 ${
        onClick ? "cursor-pointer text-left" : ""
      }`}
    >
      <Sparkles className="h-3 w-3 shrink-0 text-purple-500" />

      {alerts.length === 0 && (
        <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${NEUTRAL}`}>
          Sem alertas
        </span>
      )}

      {alerts.map((alert) => (
        <span
          key={alert.label}
          className={`rounded-full px-2 py-0.5 text-xs font-medium ${alert.badge}`}
        >
          {alert.label}
        </span>
      ))}

      {topics.map((topic) => (
        <span
          key={topic}
          className={`rounded-full px-2 py-0.5 text-xs font-medium ${TOPIC}`}
        >
          {topic}
        </span>
      ))}
    </Wrapper>
  );
};

export default AnalysisTags;
